import queryString from 'query-string'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { ReactComponent as FileInvoiceIcon } from '../../../../assets/icons/file-invoice.svg'
import { ReactComponent as MainProfessional } from '../../../../assets/icons/user-alt.svg'
import { ReactComponent as FreelancerProfessionals } from '../../../../assets/icons/users.svg'
import BackButton from '../../../../components/BackButton'
import BarChart from '../../../../components/BarChart'
import Card from '../../../../components/Card'
import ExpandableCard from '../../../../components/Card/ExpandableCard'
import Tag from '../../../../components/Tag'
import useGoTo from '../../../../hooks/useGoTo'
import { formatMoney } from '../../../../utils/formatters'
import { functionalitiesHelper } from '../../../../utils/functionalitiesHelper'
import DateHeader from '../../Dashboard/components/DateHeader'
import { INFO_DETAILS, getCharts } from './constants'
import { useBillingDetails } from './hooks/useBillingDetails'
import SideMenuTemplate from '../../templates/SideMenu'
import * as S from './styles'

const BillingDetails = () => {
  const { getDates } = functionalitiesHelper
  const { search } = useLocation()
  const goToPage = useGoTo()
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { monthAndYear, day, fullDate } = getDates(date)
  const billingData = useBillingDetails(professional.id, fullDate, sameDate)
  const loading = !billingData
  const barChartData = !loading ? getCharts(billingData, sameDate) : []
  const header = {
    title: monthAndYear,
    subtitle: `Informações ${sameDate ? 'deste mês ' : ''} até o dia ${day}`,
    loading
  }
  return (
    <SideMenuTemplate>
      <BackButton text='Detalhes dos faturamentos' backPage='/vets/dashboard' paramData={`?date=${date}`} />
      <S.Container>
        <DateHeader {...header} />
        <ExpandableCard {...INFO_DETAILS}>
          <S.InfoCard>
            <hr />
            O Faturamento bruto apresenta o valor de todos os serviços realizados no mês.
            Para saber o quanto você vai receber, é preciso fazer o cálculo do seu percentual.
          </S.InfoCard>
        </ExpandableCard>
        <S.CardWrapper>
          <Card full>
            <S.CardBody>
              <S.CardSection justifyContent='space-between'>
                <section>
                  <S.CardTitle>Faturamento diário</S.CardTitle>
                  <S.CardSubtitle>Consulte quanto foi faturado em cada dia do mês.</S.CardSubtitle>
                </section>
                <FileInvoiceIcon />
              </S.CardSection>
              <S.ActionButton outline size='small' onClick={() => goToPage('/vets/dashboard/billing/daily', `?date=${date}&sameDate=${sameDate}`)}>Detalhes</S.ActionButton>
            </S.CardBody>
          </Card>
        </S.CardWrapper>
        { loading ? <S.SkeletonCard type='card' /> : <S.CardWrapper>
          <Card full>
            <S.CardBody>
              <S.CardSection isDisabled={billingData?.professionalsAmount.professional === 0}>
                <MainProfessional />
                <section>
                  <S.CardTitle><strong>{formatMoney(billingData?.professionalsAmount.professional)}</strong></S.CardTitle>
                  <S.CardSubtitle>são de atendimentos realizados pelo <strong>profissional principal</strong></S.CardSubtitle>
                </section>
              </S.CardSection>
              <S.CardSection isDisabled={!billingData?.professionalsAmount.freelancers}>
                <FreelancerProfessionals />
                <section>
                  <S.CardTitle><strong>{formatMoney(billingData?.professionalsAmount.freelancers)}</strong></S.CardTitle>
                  <S.CardSubtitle>são de atendimentos realizados pelos <strong>profissionais substitutos</strong></S.CardSubtitle>
                </section>
              </S.CardSection>
              <hr />
              <Tag>{formatMoney(billingData?.professionalsAmount.monthTotalBalance)} de faturamento bruto</Tag>
            </S.CardBody>
          </Card>
        </S.CardWrapper>}
        <BarChart
          {...barChartData}
          type='list'
          barStyle={{ height: '16px' }}
          maxColor
          breakLine
          transformData={{ value: formatMoney }}
          loading={loading}
        />
      </S.Container>
    </SideMenuTemplate>
  )
}

export default BillingDetails
